import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";

import * as serviceWorker from "./serviceWorker";

import { HashRouter } from "react-router-dom";
import "./assets/base.scss";
import Main from "./DemoPages/Main";
import configureStore from "./config/configureStore";
import { Provider } from "react-redux";

const store = configureStore();
const rootElement = document.getElementById("root");

// Ignore noisy known non-fatal browser/SDK warnings.
const isKnownNoise = (message = "", stack = "") => {
  if (typeof message !== "string") return false;

  const isResizeObserverNoise =
    message.includes("ResizeObserver loop completed with undelivered notifications") ||
    message.includes("ResizeObserver loop limit exceeded");

  const isGenesysSocketNoise =
    message.includes("WebSocket closed with reason:") &&
    message.includes("(1006)") &&
    (String(stack).toLowerCase().includes("genesys") ||
      String(stack).toLowerCase().includes("webmessaging.mypurecloud.ie"));

  return isResizeObserverNoise || isGenesysSocketNoise;
};

window.addEventListener(
  "error",
  (event) => {
    const message = event?.message || event?.error?.message || "";
    const stack = event?.error?.stack || "";
    if (!isKnownNoise(message, stack)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reasonMessage =
      event?.reason?.message ||
      (typeof event?.reason === "string" ? event.reason : "");
    const reasonStack = event?.reason?.stack || "";
    if (!isKnownNoise(reasonMessage, reasonStack)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

const renderApp = (Component) => {
  ReactDOM.render(
    <Provider store={store}>
      <HashRouter>
        <Component />
      </HashRouter>
    </Provider>,
    rootElement
  );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept("./DemoPages/Main", () => {
    const NextApp = require("./DemoPages/Main").default;
    renderApp(NextApp);
  });
}
serviceWorker.unregister();
